/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphototitle3Inputs */

const en_aiflowphototitle3 = /** @type {(inputs: Aiflowphototitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_aiflowphototitle3 = /** @type {(inputs: Aiflowphototitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Aiflowphototitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphototitle3 = /** @type {((inputs?: Aiflowphototitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphototitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphototitle3(inputs)
	return de_aiflowphototitle3(inputs)
});
export { aiflowphototitle3 as "aiFlowPhotoTitle" }